import React, { Component, ErrorInfo, ReactNode } from "react";
import { Trans } from "react-i18next";
interface Props { 
  children?: ReactNode ;
};
interface State { 
  hasError: boolean ;
};

class ErrorBoundary extends Component<Props, State> {
  
  public state: State = {
    hasError: false
  }
  public static getDerivedStateFromError(_:Error): State{
    return {
      hasError: true
    };
  }
  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.log(error, errorInfo);
  }
  public render() {
    if(this.state.hasError){
        <p className="errorMessage">
          <Trans i18nKey={"component_error"}></Trans>
        </p>;
    }
    return this.props.children;
  }
};

export default ErrorBoundary;
